export enum EMagicSignInStages {
  REQUEST_SIGN_IN_URI = 'request_sign_in_uri',
  REQUEST_JWT = 'request_jwt',
}
